import { connect } from 'react-redux';

import { DeleteButton } from 'modules/layout';

import { selectInfoItemPending } from '../../services/selectors';
import { deleteInfoRequest } from '../../services/actions';

export default connect(
    (state, { id }) => ({
        pending: selectInfoItemPending(state, { id }),
    }),
    (dispatch, { id, categoryId }) => ({
        handleDelete: () => {
            dispatch(deleteInfoRequest(id, categoryId));
        },
    }),
)(DeleteButton);
